import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { contactInfo } from '../mock/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <h3 className="text-3xl font-bold text-amber-400 mb-4">CAMEL</h3>
              <p className="text-gray-300 mb-4 leading-relaxed">
                Premium quality rubber bushes for submersible pumps. Built to withstand extreme 
                heat and sand, ensuring your equipment runs efficiently in any condition.
              </p>
              <div className="flex items-center space-x-2 text-amber-300 italic">
                <p className="font-medium">"Unyielding in Heat, Unstoppable in Sand"</p>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-xl font-bold text-amber-400 mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <button 
                    onClick={() => scrollToSection('home')}
                    className="text-gray-300 hover:text-amber-400 transition-colors"
                  >
                    Home
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('about')}
                    className="text-gray-300 hover:text-amber-400 transition-colors"
                  >
                    About Us
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('benefits')}
                    className="text-gray-300 hover:text-amber-400 transition-colors"
                  >
                    Benefits
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('pricing')}
                    className="text-gray-300 hover:text-amber-400 transition-colors"
                  >
                    Pricing
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('testimonials')}
                    className="text-gray-300 hover:text-amber-400 transition-colors"
                  >
                    Testimonials
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-xl font-bold text-amber-400 mb-4">Contact Us</h4>
              <ul className="space-y-3">
                <li className="flex items-start space-x-2">
                  <Phone className="text-amber-400 mt-1 flex-shrink-0" size={18} />
                  <a 
                    href={`tel:${contactInfo.phone}`}
                    className="text-gray-300 hover:text-amber-400 transition-colors"
                  >
                    {contactInfo.phone}
                  </a>
                </li>
                <li className="flex items-start space-x-2">
                  <Mail className="text-amber-400 mt-1 flex-shrink-0" size={18} />
                  <a 
                    href={`mailto:${contactInfo.email}`}
                    className="text-gray-300 hover:text-amber-400 transition-colors break-all"
                  >
                    {contactInfo.email}
                  </a>
                </li>
                <li className="flex items-start space-x-2">
                  <MapPin className="text-amber-400 mt-1 flex-shrink-0" size={18} />
                  <span className="text-gray-300 text-sm">
                    {contactInfo.address}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              {/* Copyright */}
              <p className="text-gray-400 text-sm text-center md:text-left">
                © {currentYear} Camel Rubber Industries. All rights reserved.
              </p>

              {/* Social Media */}
              <div className="flex items-center space-x-4">
                <a 
                  href="#" 
                  className="bg-gray-800 p-2 rounded-lg hover:bg-amber-600 transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook size={20} />
                </a>
                <a 
                  href="#" 
                  className="bg-gray-800 p-2 rounded-lg hover:bg-amber-600 transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram size={20} />
                </a>
                <a 
                  href="#" 
                  className="bg-gray-800 p-2 rounded-lg hover:bg-amber-600 transition-colors"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
